module.exports = __webpack_public_path__ + "img/04.af654a3f.png";